module.exports = "<iframe src=\"{{:src}}\" title=\"{{:title}}\" width=\"{{:width}}\" height=\"{{:height}}\" style=\"{{:style}}\" allowfullscreen frameborder=\"0\" scrolling=\"no\"></iframe>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/VO2/libs/core/kakaotv-url-player/iframe.hbs
 ** module id = 37
 ** module chunks = 0 1
 **/